import React, { useEffect, useState } from 'react';

const ContactStrip = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section className="relative py-16 sm:py-20 bg-slate-800/80 text-white overflow-hidden border-y border-slate-700/50">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-900/40 to-slate-900" />
      
      {/* Animated gradient blobs */}
      <div 
        className="absolute top-0 right-0 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl animate-pulse"
        style={{
          transform: `translate(${mousePosition.x * 0.02}px, ${mousePosition.y * 0.02}px)`,
        }}
      />
      <div 
        className="absolute bottom-0 left-0 w-48 h-48 bg-teal-400/20 rounded-full blur-3xl animate-pulse delay-1000"
        style={{
          transform: `translate(${mousePosition.x * -0.015}px, ${mousePosition.y * -0.015}px)`,
        }}
      />

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(teal 1px, transparent 1px), linear-gradient(90deg, teal 1px, transparent 1px)',
        backgroundSize: '50px 50px',
      }} />

      {/* Floating particles */}
      {[...Array(6)].map((_, i) => (
        <div
          key={i}
          className="absolute w-1 h-1 bg-teal-400 rounded-full opacity-60"
          style={{
            left: `${20 + i * 15}%`,
            top: `${30 + (i % 2) * 40}%`,
            animation: `float ${3 + i * 0.5}s ease-in-out infinite`,
            animationDelay: `${i * 0.3}s`,
          }}
        />
      ))}

      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <h2 className="text-2xl sm:text-3xl font-bold mb-3 relative inline-block">
          <span className="relative z-10">پروژه دارید؟</span>
          <span className="absolute bottom-0 right-0 w-full h-1 bg-teal-500/30 rounded-full animate-[pulse_2s_ease-in-out_infinite]" />
        </h2>
        <p className="text-slate-300 text-base mb-8 max-w-md mx-auto">
          برای مشاوره و شروع پروژه با ما در تماس باشید.
        </p>
        <a
          href="https://wa.me/09134378347"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-400 text-white px-6 py-3.5 rounded-lg text-sm font-medium shadow-lg shadow-teal-500/30 hover:shadow-teal-500/50 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
        >
          <span className="relative z-10">تماس با واتساپ</span>
          <svg className="w-4 h-4 relative z-10 group-hover:translate-x-[-2px] transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-600 translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500" />
        </a>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) translateX(0);
          }
          50% {
            transform: translateY(-15px) translateX(10px);
          }
        }
      `}</style>
    </section>
  );
};

export default ContactStrip;
